/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import './src/assets/scss/main.scss';

// Matomo: the snippet in gatsby-ssr.js tracks the initial page view; client
// side route changes have to be reported manually.
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (prevLocation && window._paq) {
    window._paq.push(['setCustomUrl', location.pathname]);
    window._paq.push(['setDocumentTitle', document.title]);
    window._paq.push(['trackPageView']);
  }
};
